<ion-content>
  <ion-row class="p-0">
    <img src="././assets/icon/forgotPasswordtoprightCorner.png" class="forgotPasswordtoprightCorner">
    <div class="forgotCard">
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="text-center">
          <img class="h-80 logoImg" src="././assets/icon/Phiedge-logo_HRMS.png">
        </ion-col>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="mt-20 text-center">
          <div class="formLabelSemiBoldfs24 fs-18ForMobileView">RESET PASSWORD</div>
          <div class="clear20"></div>
        </ion-col>
      </ion-row>
      <form [formGroup]="loginForm" (ngSubmit)="onClickForgotPassword()">
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="mt-10">
            <img src="././assets/icon/emailIcon.svg" class="mailIcon">
            <input type="text" placeholder="Email ID" class="inputstyle font_regular olnone form-control" autocomplete="off" formControlName="email">
          </ion-col>
          <label class="red-cl font_regular fs-12 pl-5" *ngIf="formSubmitted && loginForm.controls['email'].hasError('required')">
            Email ID is required</label>
            <label class="red-cl font_regular fs-12 pl-5" *ngIf="formSubmitted && loginForm.controls['email'].hasError('pattern')">
              Please Enter Correct Email ID</label>
        </ion-row>
        <div class="clear20"></div>
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <button type="submit" class="text-center fs-16 fs_14ForMobile font_semibold login-btn">Password Reset Link</button>
          </ion-col>
        </ion-row>
      </form>
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="mt-10 text-center">
          <label class="formLabelRegularfs16 fs_14ForMobile">Back to&nbsp;<u class="fs-16 font_medium cp link" (click)="onClickLogin()">Login</u></label>
        </ion-col>
      </ion-row>
    </div>
    <img src="././assets/icon/forgotPasswordBottomLeftCorner.png" class="forgotPasswordBottomLeftCorner">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="d-flex justify-content-flex-end">
        <div class="bottomPosFixed">
          <div class="pl-10 fs-10 font_regular text_gray">Powered By:</div>
          <img class="powerdByIcon" src="././assets/icon/Phiedge-logo_HRMS.png">
        </div>
      </ion-col>
    </ion-row>
  </ion-row>
</ion-content>